<section class="col-seleccion">
  <ticketing-stepper></ticketing-stepper>
  
  <!-- SECCIÓN 1: VALIDACIÓN -->
  <fieldset class="seccion-busqueda">
    <amigos-thyssen-validacion></amigos-thyssen-validacion>
  </fieldset>
  
  <!-- SECCIÓN 2: SELECCIÓN DE ENTRADAS (solo se muestra cuando hay validación exitosa) -->
  <fieldset class="seccion-tarifas" *ngIf="hayValidacionExitosa">
    <amigos-thyssen-selector-mas-entradas></amigos-thyssen-selector-mas-entradas>
  </fieldset>
  
  <!-- BOTÓN CONTINUAR -->
  <div class="btn-continuar-wrap">
    <ticketing-siguiente-button></ticketing-siguiente-button>
  </div>
</section>

<!-- RESUMEN DE COMPRA -->
<ticketing-resumen-compra></ticketing-resumen-compra>

